import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';
import { useEffect } from 'react';
import { sendNotification } from '@/lib/emailService';

interface ErrorFallbackProps {
    error?: Error; // PostHogErrorBoundary might pass error prop? Actually it passes nothing to the fallback usually unless it's a function child.
    // Docs say: fallback={<FallbackComponent />}
    // Usually fallback prop takes a ReactNode.
}

export const ErrorFallback = ({ error }: ErrorFallbackProps) => { // Changed types to include error prop
    useEffect(() => {
        if (error) {
            // Send alert (debounced preferably, but keeping simple)
            sendNotification(
                `Critical Error: ${error.message}`,
                "Application Crashed",
                `<p><strong>Error Type:</strong> ${error.name}</p>
         <p><strong>Message:</strong> ${error.message}</p>
         <p><strong>Stack Trace:</strong><pre style="background:#f4f4f4;padding:10px;">${error.stack}</pre></p>`
            );
        }
    }, [error]);

    return (
        <div className="min-h-screen flex items-center justify-center p-4 bg-background">
            <Card className="max-w-lg w-full">
                <CardHeader>
                    <div className="flex items-center gap-3">
                        <AlertTriangle className="h-8 w-8 text-destructive" />
                        <div>
                            <CardTitle>Something went wrong</CardTitle>
                            <CardDescription>
                                We've encountered an unexpected error
                            </CardDescription>
                        </div>
                    </div>
                </CardHeader>
                <CardContent className="space-y-4">
                    <div className="flex gap-3">
                        <Button onClick={() => window.location.href = '/'} className="flex-1">
                            Return to Home
                        </Button>
                        <Button
                            onClick={() => window.location.reload()}
                            variant="outline"
                            className="flex-1"
                        >
                            Reload Page
                        </Button>
                    </div>
                    <p className="text-xs text-muted-foreground text-center">
                        This error has been automatically reported to our team.
                    </p>
                </CardContent>
            </Card>
        </div>
    );
};
